export default __webpack_public_path__ + "static/2-621d3c0a2cfaa21184afa2b016290841.jpeg";